import { render } from "./logo-nationalgalerie.svg?vue&type=template&id=854382a8"
const script = {}

import exportComponent from "/codebuild/output/src377198440/src/2021-facebook-ang-immersivepainting/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__